<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="T5" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u7gn6cgoj31hc0rsn0a.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u9feuixgj30ku0rs75m.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation2" :style="{width: clientWidth * 0.625 + 'px'}">
            <div>
                <p style="margin-top: 300px;"><img :width="clientWidth * 0.212" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u941clazj30bc02q0su.jpg"/></p>
                <h4 style="font-size: 14px; color: #999; margin-top: 168px;">可选颜色</h4>
                <div class="pro_color_box">
                    <ul>
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>时尚黑</li>
                        <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>高级灰</li>
                    </ul>
                </div>
            </div>
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
            </div>
        </div>
        <!-- 移动端轮播图 -->
        <div class="pro_animation">
            <p style=" margin-top: 2.048rem; text-align: center;"><img style="width: 7.5093rem;" src="https://wx4.sinaimg.cn/large/0067mezugy1g6u9k1zt9ij309s03vt8s.jpg"/></p>
            <div>
                <swiper :options="swiperOption" v-if="seletedColor === 0">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones1" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <swiper :options="swiperOption" v-else-if="seletedColor === 1">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in earphones2" :key="index">
                        <div class="pro_animation_item"><img :src="item" /></div>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                    <div class="swiper-button-next" slot="button-next"><i></i></div>
                </swiper>
                <div class="pro_color_box">
                    <ul>
                        <li :class="{active: seletedColor == 0}" @click="switchColor(0)"><i></i>时尚黑</li>
                        <li :class="{active: seletedColor == 1}" @click="switchColor(1)"><i></i>高级灰</li>
                    </ul>
                </div>
            </div>
        </div>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g6u7gnu5q0j31hc0rs76l.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g6u7go9zp2j31hc0rs0x2.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g6u7goprw8j31hc0rstb6.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g6u7gp9izsj31hc0rstcp.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u7gq8br0j31hc0rsdhu.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g6u7gqqegpj31hc0rs0ue.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u7gr668xj31hc0rswhi.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1g6u7gsh5mgj31hc0rs0uf.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g6u9ffjp3hj30ku0rs40e.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1g6u9fgcv5nj30ku0rsdhd.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1g6u9fh66iij30ku0rs0u5.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g6u9fhxxplj30ku0rsjt2.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1g6u9figpypj30ku0rsq3q.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1g6u9fiuhmkj30ku0rswfq.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones2: ["https://wx3.sinaimg.cn/large/0067mezugy1g6u90jr5o7j30m80m83yo.jpg", "https://wx1.sinaimg.cn/large/0067mezugy1g6u90kahchj30m80m8aa7.jpg", "https://wx1.sinaimg.cn/large/0067mezugy1g6u90kqx8nj30m80m8aa8.jpg"],
            earphones1: ["https://wx3.sinaimg.cn/large/0067mezugy1g6u90hbrd9j30m80m8glt.jpg", "https://wx3.sinaimg.cn/large/0067mezugy1g6u90ijynuj30m80m80sx.jpg", "https://wx4.sinaimg.cn/large/0067mezugy1g6u90j1s93j30m80m8dg1.jpg"],
            clientWidth: document.body.clientWidth
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        },
        mounted() {
            window.addEventListener("resize", () => {
                this.clientWidth = document.body.clientWidth
            })
        }
    }
}
</script>
<style scoped>

.pro_color_box li:nth-child(1) i::before{
	background: #342c2a;
}

.pro_color_box li:nth-child(2) i::before{
	background: #a1a1a1;
}

.pro_animation2 .pro_animation_item{
    /* height: 800px; */
    padding-bottom: 100px; 
}


.pro_animation2 .swiper-container{
    margin-top: 20px;
    /* width: 500px; */
}

.pro_animation2 .pro_color_box{
    margin-bottom: 260px;
}


@media (max-width: 768px) {
    
    /* .pro_animation_item img{
		width: 16rem; 
    } */
    
    .pro_color_box{
        width: 7.9733rem;
        margin: 2.1333rem auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/T/t5.vue